export default __webpack_public_path__ + "static/media/sso_facebook.7f27c723.svg";